var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GalaHonor',{attrs:{"estimated-score":_vm.galaHonor.spiderTanks.estimatedHonorChange,"full-earning-available":_vm.galaHonor.spiderTanks.currentHonor === 1200,"score":_vm.galaHonor.spiderTanks.currentHonor,"tooltip-body":_vm.$t('pages.galaHonor.tooltipBody'),"tooltip-title":_vm.$t('pages.galaHonor.tooltipTitle')}}),_vm._v(" "),_c('div',{staticClass:"gala-honor-info is-flex row justify-center"},[_c('div',{},[_c('div',{staticClass:"honor-info-title"},[_vm._v(_vm._s(_vm.$t('pages.galaHonor.ydd')))]),_vm._v(" "),_c('div',{staticClass:"is-flex row justify-center"},[_c('div',{staticClass:"ydd-icon"}),_vm._v(" "),_c('div',{staticClass:"honor-info-value"},[_vm._v(_vm._s(_vm.distributionResults)+" SILK")])])])]),_vm._v(" "),_c('div',{staticClass:"is-flex row",staticStyle:{"margin-top":"1rem"}},[_c('GalaHonorActions',{attrs:{"type":"positive","actions":[
        {
          title: _vm.$t('pages.galaHonor.playAndEarnDescription'),
          buttonTitle: 'Play now',
          path: '/games/spider-tanks',
        },
        {
          title: _vm.$t('pages.galaHonor.runNodeDescription'),
          buttonTitle: 'Buy Node',
          path: '/nodes/spider-tanks-planetary-node/buy',
        },
        {
          title: _vm.$t('pages.galaHonor.bridgeCurrencyToGyriDescription', {
            currency: 'SILK',
          }),
          buttonTitle: 'Bridge SILK',
          path: '/inventory/SILK[ETH]',
        } ]}}),_vm._v(" "),_c('GalaHonorActions',{attrs:{"type":"negative","actions":[
        {
          title: _vm.$t('pages.galaHonor.bridgeCurrencyToEthDescription', {
            currency: 'SILK',
          }),
        },
        {
          title: _vm.$t('pages.galaHonor.transferCurrencyDescription', {
            currency: 'SILK',
          }),
        } ]}}),_vm._v(" "),_c('GalaHonorActions',{attrs:{"actions":[
        {
          title: _vm.$t('pages.galaHonor.purchaseDescription', {
            currency: 'SILK[ETH]',
          }),
          buttonTitle: 'Go to Store',
          path: '/games/spider-tanks',
        } ],"type":"redeeming"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }